<template>
  <div>
    <v-card v-if="hasPrevious">
      <v-container class="pt-0 pb-0">
        <v-layout>
          <v-btn id="help-back-btn" :aria-label="backTo" small flat class="back-btn" @click="goBack">
            <v-icon>arrow_back</v-icon>
            <span>{{backTo}}</span>
          </v-btn>
        </v-layout>
      </v-container>
    </v-card>
    <v-container>
      <div v-html="article.title" class="headline mb-2"></div>
      <v-layout row xs12>
        <p v-html="article.content"></p>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { alternateRouteName } from '../../HelperMethods'

export default {
  computed: {
    ...mapState({
      previousRoute: state => state.profile.previousRoute
    }),
    backTo () {
      let route = alternateRouteName(this.previousRoute)
      if (this.$i18n.keyExists(route)) {
        return this.$t('student.help.back_to') + ' ' + this.$t(route)
      } else {
        return this.$t('student.help.back_to') + ' ' + route
      }
    },
    hasPrevious () {
      return this.previousRoute.name !== null
    },
    article () {
      let title = `student.help.articles.${this.$route.params.id}.title`
      let content = `student.help.articles.${this.$route.params.id}.content`
      return {
        title: this.$i18n.keyExists(title) ? this.$t(title) : '',
        content: this.$i18n.keyExists(content) ? this.$t(content).join(' ') : ''
      }
    }
  },
  methods: {
    goBack () {
      this.$router.push(this.previousRoute.path)
    }
  }
}
</script>

<style scoped>
  .back-btn {
    text-transform: none;
    margin-left: 0px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/help/SupportPage.vue